import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy bookmark redirect. Pre-FSU `/admin/finance/contributions` lands at
// the unified transactions workspace's staged pivot — same destination the
// FPD-028 `$contributionId` drilldown route reaches, just without an id.
export const Route = createFileRoute('/admin/finance/contributions/')({
  beforeLoad: () => {
    throw redirect({
      to: '/admin/finance/transactions',
      search: { status: 'staged' as const, view: 'match' as const },
    });
  },
});
